import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { Backdrop, SceneTitle, glow } from "./shared";

const SOLUTIONS = [
  { icon: "💰", title: "₹3K/month",         detail: "5 users · 3 domains included" },
  { icon: "🔒", title: "Self-hosted",         detail: "Your VPS. Your data. Zero lock-in." },
  { icon: "🛡️", title: "Postgres RLS",        detail: "Tenant-isolated at the database layer" },
  { icon: "🌐", title: "Unlimited domains",    detail: "Marketing, Ops, Legal — one brain" },
  { icon: "🎯", title: "72% accuracy",        detail: "Tree-sitter AST · hybrid search · graph RAG" },
];

export const Scene05FounderSolve: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 30, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const titleAp = interpolate(spring({ frame, fps, config: SPRING.snappy }), [0, 1], [0, 1], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={COLORS.neonGreen} />

      <SceneTitle
        text="EAKC solves it"
        subtitle="Priced for you. Built like enterprise."
        color={COLORS.neonGreen}
        frame={frame}
        appear={titleAp}
      />

      {/* 5 solution cards in 3D cascade */}
      <div style={{
        position: "absolute",
        top: 280,
        left: 0, right: 0,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 36,
        perspective: 1400,
        padding: "0 80px",
      }}>
        {SOLUTIONS.map((s, i) => {
          const delay = 20 + i * 18;
          const sp = spring({ frame: frame - delay, fps, config: SPRING.bouncy });
          const op = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const scale = interpolate(sp, [0, 1], [0.4, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const tilt = (i - 2) * 3;
          const float = Math.sin(frame * 0.024 + i * 0.9) * 10;
          return (
            <div key={s.title} style={{
              width: 340,
              height: 300,
              opacity: op,
              transform: `scale(${scale}) translateY(${float}px) rotateY(${tilt}deg) rotateX(${Math.sin(frame * 0.015 + i) * 3}deg)`,
              transformStyle: "preserve-3d",
            }}>
              <div style={{
                width: "100%",
                height: "100%",
                background: `linear-gradient(140deg, ${COLORS.neonGreen}22, ${COLORS.bgCard}ee)`,
                border: `2.5px solid ${COLORS.neonGreen}`,
                borderRadius: 22,
                padding: 28,
                boxShadow: `0 0 40px ${COLORS.neonGreen}55, 0 0 80px ${COLORS.neonGreen}22, 0 20px 40px rgba(0,0,0,0.5)`,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 16,
              }}>
                <div style={{ fontSize: 80 }}>{s.icon}</div>
                <div style={{
                  fontSize: 32,
                  fontFamily: FONTS.heading,
                  fontWeight: 900,
                  color: COLORS.neonGreen,
                  textShadow: glow(COLORS.neonGreen, true),
                  textAlign: "center",
                  letterSpacing: -0.5,
                }}>
                  {s.title}
                </div>
                <div style={{
                  fontSize: 18,
                  fontFamily: FONTS.body,
                  color: COLORS.textSecondary,
                  textAlign: "center",
                  lineHeight: 1.3,
                }}>
                  {s.detail}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
